// <s-sticky-add-to-cart> — bar pinned to the bottom of product pages. It slides in once the
// main Add to cart button has scrolled out of view and taps that same button, so the chosen variant,
// quantity and purchase option all carry over. Hidden when the product is sold out. One component per file.
class SStickyAddToCart extends HTMLElement {
  #ac = null;
  #observer = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const button = this.querySelector('[data-sticky-add]');
    if (!button) return;

    button.addEventListener('click', () => {
      const main = this.#mainButton();
      if (main) main.click();
    }, { signal: this.#ac.signal });

    const target = document.querySelector('[data-product-form]');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const pastForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#toggle(pastForm && Boolean(this.#mainButton()));
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #mainButton() {
    const main = document.querySelector('[data-product-form] button[name="add"]');
    if (!main || main.getAttribute('aria-disabled') === 'true') return null;
    return main;
  }

  #toggle(show) {
    if (show) {
      const price = document.querySelector('[data-product-price]');
      const slot = this.querySelector('[data-sticky-price]');
      if (price && slot) slot.textContent = price.textContent.replace(/\s+/g, ' ').trim();
    }
    this.toggleAttribute('data-visible', show);
    this.querySelector('[data-sticky-bar]')?.toggleAttribute('inert', !show);
  }
}

if (!customElements.get('s-sticky-add-to-cart')) {
  customElements.define('s-sticky-add-to-cart', SStickyAddToCart);
}
